import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

import { AccessoryStartingWithResponseModelSchema } from '../schemas/AccessoryStartingWithResponseModel';
import { AdvancedSearchFilterTypeSchema } from '../schemas/AdvancedSearchFilterType';

// No PathParameters

export const QueryParametersSchema = z.object({
	SearchTerm: z.string().optional(),
	ShowOnlyDeleted: z.boolean().optional(),
	AdvancedSearchFilterSource: z.lazy(() => AdvancedSearchFilterTypeSchema).optional(),
});
export type QueryParameters = z.infer<typeof QueryParametersSchema>;

// No RequestBody

const ResponseDataSchema = z.lazy(() => AccessoryStartingWithResponseModelSchema);
export type ResponseData = z.infer<typeof ResponseDataSchema>;
const validator = createValidator(ResponseDataSchema);

export async function callApi(input: {
	queryParameters: QueryParameters;
}): Promise<Optional<ResponseData>> {
	const url: string = SERVICEBASEURL.BACKEND + `/Accessory/StartingWith`;
	return (
		await axios
			.get(url, {
				params: input.queryParameters,
			})
			.toOptionalFiltered(validator)
	).map((x) => x.data);
}
